import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';

import { environment } from '../../../../environments/environment.development';
import { STORAGE_ENUM } from '../../../auth/enums/storage.enum';
import { SessionService } from '../../../auth/services/session/session.service';
import { LocalStorageService } from '../../../shared/services/local-storage/local-storage.service';
import { Event } from '../../models/events.model';
import { Task } from '../../models/mip/task.model';
import { Ticket } from '../../models/tickets/ticket.model';

@Injectable({
  providedIn: 'root'
})
export class StatsService {
  private _http = inject(HttpClient);
  private _sessionService = inject(SessionService);
  private _localStorage = inject(LocalStorageService);

  private _baseUrl = `${environment.apiUrl}/administrative`;

  getOpenTickets(page: number = 1): Observable<Ticket[]> {
    const token = this._localStorage.get(STORAGE_ENUM.TOKEN);

    const headers = {
      Authorization: `Bearer ${token}`
    };

    if (!token) {
      return throwError(() => new Error('Error getting open tickets'));
    }

    const isMainCustomer = this._sessionService.Customer.is_main;
    const customerId = this._sessionService.Customer.id;

    let ticketsUrl = `${this._baseUrl}/tickets/?customer=${customerId}`;

    if (isMainCustomer) {
      ticketsUrl += `&customer__main_customer=${customerId}`;
    }

    return this._http.get<Ticket[]>(
      `${ticketsUrl}&page=${page}&page_size=10`,
      { headers }
    );
  }

  getPendingServices(page: number = 1): Observable<Event[]> {
    const token = this._localStorage.get(STORAGE_ENUM.TOKEN);

    const headers = {
      Authorization: `Bearer ${token}`
    };

    if (!token) {
      return throwError(() => new Error('Error getting pending services'));
    }

    const isMainCustomer = this._sessionService.Customer.is_main;
    const customerId = this._sessionService.Customer.id;

    let servicesUrl = `${this._baseUrl}/events/`;
    servicesUrl += `?customer=${customerId}`;

    if (isMainCustomer) {
      servicesUrl += `&customer__main_customer=${customerId}`;
    }

    return this._http.get<Event[]>(
      `${servicesUrl}&page=${page}&page_size=10&status__name=Creado`,
      { headers }
    );
  }

  getTasks(page: number = 1): Observable<Task[]> {
    const token = this._localStorage.get(STORAGE_ENUM.TOKEN);

    const headers = {
      Authorization: `Bearer ${token}`
    };

    if (!token) {
      return throwError(() => new Error('Error getting tasks'));
    }

    const isMainCustomer = this._sessionService.Customer.is_main;
    const customerId = this._sessionService!.Customer.id;

    let tasksUrl = `${this._baseUrl}/tasks/tasks/?customer=${customerId}`;

    if (isMainCustomer) {
      tasksUrl += `&customer__main_customer=${customerId}`;
    }

    return this._http.get<Task[]>(
      `${tasksUrl}&page=${page}&page_size=10`,
      { headers }
    );

    /* return this._http.get<Task[]>(
      `${this._baseUrl}/tasks/tasks/`,
      { headers }
    ); */
  }
}
